import { HighlightCard } from "./Highlights";
import { EmojiEvents, EventAvailable } from "@mui/icons-material";

export const Results = ({ event }) => (
    <HighlightCard
        backgroundColor={theme => theme.palette.highlights.results_published}
        text={event.status === "finished" ? "Complete" : "Results published"}
        icon={event.status === "finished" ? <EventAvailable fontSize="inherit" /> :<EmojiEvents fontSize="inherit" />}
        name={event.name}
        to={`/events/${event.id}`}
    />
);
